import {
  Box,
  Typography,
  Input,
  Divider,
  Select,
  MenuItem,
} from "@mui/material";
import React from "react";
import { useTheme } from "@mui/material/styles";

const SelectLanguage = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        background: theme.palette.grey[50],
        padding: "0% 3% 0% 3%",
      }}
    >
      <Typography
        fontSize={{ xs: "15px", md: "2vw", lg: "1vw" }}
        fontWeight="600"
        color={theme.palette.primary.main}
        mr="1%"
      >
        Language
      </Typography>
      {/* <Typography>{">"}</Typography> */}
      <Select
        // inputProps={{ IconComponent: () => null }}
        sx={{
          boxShadow: "none",
          ".MuiOutlinedInput-notchedOutline": { border: 0 },
          height: "30px",
          fontSize: { xs: "15px", md: "2vw", lg: "1vw" },
          color: theme.palette.primary.main,
        }}
        value="English"
      >
        <MenuItem value="English">
          {" "}
          <Typography
            fontSize={{ xs: "15px", md: "2vw", lg: "1vw" }}
            color={theme.palette.primary.main}
          >
            English
          </Typography>
        </MenuItem>
      </Select>
    </Box>
  );
};

export default SelectLanguage;
